import { ChevronRight } from "@material-ui/icons";
import { Grid, Typography } from "@mui/material";
import { CurrencyDisplay, PrimaryTextButton } from "components";

const InformationCard = ({
  title,
  value,
  prefix,
  length,
  onClick,
  buttonLabel,
}) => (
  <Grid item xs={12 / length} borderLeft="2px solid #9545EB" px="16px">
    <Typography color="#687083" fontSize={14} textAlign="right">
      {title}
    </Typography>
    <Typography fontSize="24px">
      <CurrencyDisplay
        value={value}
        prefix={prefix}
        decimalScale={prefix && 2}
      />
    </Typography>
    {onClick && (
      <PrimaryTextButton
        label={buttonLabel || "View Summary"}
        onClick={onClick}
        endIcon={<ChevronRight />}
      />
    )}
  </Grid>
);

export default InformationCard;
